import moment from 'moment';
import { PPA_STLMTS_API } from '@/api';
import config from './settlementsChargeDetailsConfig';

const state = {
  tableData: [],
  tableConfig: config.columns,
};

const actions = {
  async fetchChargeDetails({ dispatch }, params) {
    try {
      const response = await PPA_STLMTS_API.put('/statements/charge-details', params);
      dispatch('createTableData', response.data);
    } catch (error) {
      this.$notify('Failed to load PPA Charge Details', 'error');
    }
  },

  async createTableData({ commit }, data) {
    if (data && data.data && data.data.length > 0) {
      commit('reset');

      const flatArray = [];
      data.data.forEach((head) => {
        head.data.forEach((mid) => {
          mid.tradingDate = moment.utc(mid.tradingDate).format('MM/DD/YYYY');
          const newObj = {};
          Object.keys(mid).forEach((key) => {
            if (!Array.isArray(mid[key])) { newObj[key] = mid[key]; }
          });
          Object.keys(head).forEach((key) => {
            if (!Array.isArray(head[key])) { newObj[key] = head[key]; }
          });
          flatArray.push(newObj);
        });
      });
      commit('setTableData', flatArray);
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
  updateCompareConfig(state) {
    state.tableConfig[12].visible = false;
    state.tableConfig[13].visible = false;
    state.tableConfig[14].visible = false;
    state.tableConfig[15].visible = false;
    state.tableConfig[16].visible = false;
    state.tableConfig[17].visible = false;
    state.tableConfig[18].visible = true;
    state.tableConfig[19].visible = true;
    state.tableConfig[20].visible = true;
    state.tableConfig[21].visible = true;
    state.tableConfig[22].visible = true;
    state.tableConfig[23].visible = true;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};